import { getAppAutoInfo } from '@/services/utils/modules/auth'
import { syncRouteToBaseApp, getIframeContentWindowByTagId, subAppUrlToBaseUrl, isAppInnerUrl, handleSubAppDocumentClick, getIframeTagIdByWindow } from '..'
import { addPageTagAndNavigate, goLoginPage, setTagTitle } from '../pageTagUtils'
import { composeActions } from './compose-actions'
import { MESSAGE_TYPE_ENUM } from './messageType'

window.addEventListener('message', function(e) {
  if (!e?.data?.type) {
    // 没有 e.data.type 绝对不是 s 上抛的时间, 不处理
    return
  }

  console.log('[base-app] onMessage : e.data.type: ', e.data.type, e)
  const { type, payload } = e.data
  const tagId = getIframeTagIdByWindow(e.source)
  // 增加了 tagId 属性
  const fullPayload = {
    tagId,
  }
  if (typeof payload === 'object') {
    Object.assign(fullPayload, payload)
  } else {
    fullPayload.value = payload
  }

  console.log('base-app fullPayload:', fullPayload)

  if (type === MESSAGE_TYPE_ENUM.GET_BASE_APP_AUTH_INFO) {
    // 子应用获取基本认证信息, 通过 e.source.postMessage 回传消息
    const info = getAppAutoInfo()
    e.source.postMessage({
      type: MESSAGE_TYPE_ENUM.RES_GET_BASE_APP_AUTH_INFO,
      payload: info,
    }, '*')
  } else if (type === MESSAGE_TYPE_ENUM.ROUTE_SYNC_TO_BASE_APP) {
    syncRouteToBaseApp(fullPayload)
  } else if (type === MESSAGE_TYPE_ENUM.SUB_BASE__SET_TAG_TITLE) {
    setTagTitle(fullPayload)
  } else if (type === MESSAGE_TYPE_ENUM.SUB_BASE__ADD_PAGE_TAG_AND_GO) {
    const fullUrl = fullPayload.fullUrl || ''

    const ifAppInnerUrl = isAppInnerUrl(fullUrl)
    if (!ifAppInnerUrl) {
      this.window.open(fullUrl)
      return
    }

    const baseAppUrl = subAppUrlToBaseUrl(fullPayload.fullUrl || '')
    // parentTagId
    addPageTagAndNavigate(baseAppUrl, '', { ...fullPayload.options, parentTagId: fullPayload.tagId })
  } else if (e.data.type === MESSAGE_TYPE_ENUM.SUB_BASE__DOCUMENT_CLICK) {
    handleSubAppDocumentClick()
  } else if (e.data.type === MESSAGE_TYPE_ENUM.SUB_BASE__GO_LOGIN_PAGE) {
    goLoginPage(fullPayload)
  } else if (e.data.type === MESSAGE_TYPE_ENUM.SUB_BASE__PARENT_OPEN) {
    const { fullPath = '', options = {} } = fullPayload
    // options 是一个预留的选项, 目前没用
    this.window.open(fullPath)
  } else if (e.data.type === MESSAGE_TYPE_ENUM.SUB_BASE__COMPOSE_ACTIONS) {
    composeActions(fullPayload)
  }
})

export function reloadIframeBySubAppUrl(subAppUrl, tag) {
  const iframeWindow = getIframeContentWindowByTagId(tag.id)
  iframeWindow && iframeWindow.postMessage({
    type: MESSAGE_TYPE_ENUM.BASE_SUB__RELOAD_IFRAME,
    payload: {
      subAppUrl,
      tag,
    }
  }, '*')
}
